import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ children, requireAdmin = false }) => {
    const { currentUser, isAdmin, loading } = useAuth();

    if (loading) {
        return <LoadingSpinner text="Authenticating..." />;
    }

    if (!currentUser) {
        return <Navigate to="/" />;
    }

    if (requireAdmin && !isAdmin) {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

export default PrivateRoute;
